import React, { Component } from 'react';
import { Step, Steps, WithWizard, Wizard } from 'react-albus';
import SelectReportType from './Steps/SelectAdminReportType';
import FilterRecords from './Steps/FilterAdminRecords';
import SelectReportFormat from './Steps/SelectAdminReportFormat';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import './GenerateAdminReportWizard.css';
import { connect } from 'react-redux';
import { reportActions } from '../../../Reducks/Reports';
import { Button } from 'reactstrap';
import WizardBreadCrumbComponent from '../../../Components/WizardBreadCrumb/WizardBreadCrumbComponent';
import { getReportTypeInfo, validateSelection, WizardStepID } from './GenerateAdminReportWizardUtils';
import { DESKTOP_DEVICE, ReportType } from '../../../Utils/Constants';

export class GenerateReportWizard extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  };
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    isBig: PropTypes.bool.isRequired,
    reduced_webinars: PropTypes.object,
    reduced_sessions: PropTypes.object,
    reduced_user: PropTypes.object,
    submitReportGenerationJob: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      reportType: null,
      reportFormatType: null
    };
  }

  render() {
    const { t } = this.context;
    const { reportType, reportFormatType } = this.state;
    const customMargin = {
      margin: '0px 12px'
    };
    const { reduced_webinars, reduced_sessions, isBig } = this.props;
    const numberOfSelectedSessions =
      this.props.uniqueTableId === 'sesssionsTableInOverview'
        ? reduced_sessions.sessions.filteredSelectedSessionKeys.length
        : reduced_sessions.filterReportSessions.filteredSelectedSessionKeys.length;
    const numberOfSelectedWebinars = reduced_webinars.webinars.filteredSelectedWebinarKeys.length;
    const warningMessageComponent = this.validator().error !== null && <WarningMessage {...this.validator()} />;
    return (
      <Modal
        isOpen={this.props.isOpen}
        shouldCloseOnOverlayClick={true}
        className="generateReportWizardModal"
        ariaHideApp={false}
        onRequestClose={this.props.toggle}
        overlayClassName="generateReportWizardModalOverlay">
        <Wizard>
          <div className="heading">
            <div className="d-flex justify-content-between align-items-center title">
              <div>{t('report.generateReportLower')}</div>
              <i className="togo-icon togo-icon-closes close closeButton" onClick={this.props.toggle} />
            </div>
            <WizardBreadCrumb reportType={reportType} />
          </div>

          <div className="body">
            <Steps>
              <Step
                id={WizardStepID.SELECT_REPORT_TYPE}
                render={() => (
                  <SelectReportType
                    reportTypeSelected={this.state.reportType}
                    setReportType={this.setReportType}
                    isBig={this.props.isBig}
                  />
                )}
              />
              <Step
                id={WizardStepID.FILTER_RECORDS}
                render={({ push }) => (
                  <FilterRecords
                    reportType={this.state.reportType}
                    warningMessage={warningMessageComponent}
                    navigateToReportTypeRow={
                      <NavigateToReportTypeRow
                        reportType={this.state.reportType}
                        navigate={() => push(WizardStepID.SELECT_REPORT_TYPE)}
                        isBig={this.props.isBig}
                      />
                    }
                    isBig={this.props.isBig}
                  />
                )}
              />
              <Step
                id={WizardStepID.SELECT_REPORT_FORMAT}
                render={({ push }) => (
                  <SelectReportFormat
                    reportType={this.state.reportType}
                    reportFormatType={this.state.reportFormatType}
                    setReportFormatType={this.setReportFormatType}
                    navigateToReportTypeRow={
                      <NavigateToReportTypeRow
                        reportType={this.state.reportType}
                        navigate={() => push(WizardStepID.SELECT_REPORT_TYPE)}
                        isBig={this.props.isBig}
                      />
                    }
                    navigateToFilterRecordsRow={
                      <NavigateToFilterRecordsRow
                        navigate={() => push(WizardStepID.FILTER_RECORDS)}
                        reportType={reportType}
                        numberOfSelectedSessions={numberOfSelectedSessions}
                        numberOfSelectedWebinars={numberOfSelectedWebinars}
                      />
                    }
                  />
                )}
              />
            </Steps>
          </div>

          <WithWizard
            render={({ step, push }) => {
              const downloadReportButtonComponent = (
                <Button
                  id="downloadReport"
                  color="primary"
                  className={'button-dark-mode-override'}
                  disabled={
                    step.id !== WizardStepID.SELECT_REPORT_FORMAT ||
                    reportType === null ||
                    reportFormatType === null ||
                    this.validator().error !== null
                  }
                  onClick={() => this.generateReport(!isBig)}>
                  {isBig ? t('buttons.download') : t('report.emailReport')}
                </Button>
              );

              const emailReportButtonComponent = (
                <Button
                  id="downloadReport"
                  color="primary"
                  style={customMargin}
                  className={'button-dark-mode-override'}
                  disabled={
                    step.id !== WizardStepID.SELECT_REPORT_FORMAT ||
                    reportType === null ||
                    reportFormatType === null ||
                    this.validator().error !== null
                  }
                  onClick={() => this.generateReport(isBig, DESKTOP_DEVICE)}>
                  {t('report.emailReport')}
                </Button>
              );

              const navigateButtonComponent = (
                <NavigateButton
                  stepId={step.id}
                  push={push}
                  disabled={this.validator().error !== null}
                  reportType={reportType}
                  isBig={isBig}
                  reportFormatType={reportFormatType}
                />
              );
              const cancelButtonComponent = (
                <Button color="link" onClick={this.props.toggle}>
                  {t('buttons.cancel')}
                </Button>
              );
              return (
                <div className="submission">
                  {isBig ? (
                    <React.Fragment>
                      <div>
                        {warningMessageComponent && step.id === WizardStepID.FILTER_RECORDS
                          ? warningMessageComponent
                          : navigateButtonComponent}
                      </div>
                      <div className="submissionButtons">
                        {cancelButtonComponent}
                        {emailReportButtonComponent}
                        {downloadReportButtonComponent}
                      </div>
                    </React.Fragment>
                  ) : step.id === WizardStepID.SELECT_REPORT_FORMAT ? (
                    downloadReportButtonComponent
                  ) : (
                    navigateButtonComponent
                  )}
                </div>
              );
            }}
          />
        </Wizard>
      </Modal>
    );
  }

  setReportType = reportType => {
    this.setState({ reportType });
  };

  setReportFormatType = reportFormatType => this.setState({ reportFormatType });

  validator = () => {
    const { reportType } = this.state;
    const { reduced_webinars, reduced_sessions, reduced_recordings } = this.props;
    const {
      filteredSelectedTotalRegistrants,
      filteredSelectedTotalEngagementCount,
      filteredTotalRegistrants,
      filteredTotalEngagementCount
    } =
      this.props.uniqueTableId === 'sesssionsTableInOverview'
        ? reduced_sessions.stats
        : reduced_sessions.filterSessionStats;
    const numberOfSelectedSessions =
      this.props.uniqueTableId === 'sesssionsTableInOverview'
        ? reduced_sessions.sessions.filteredSelectedSessionKeys.length
        : reduced_sessions.filterReportSessions.filteredSelectedSessionKeys.length;
    const numberOfSelectedWebinars = reduced_webinars.webinars.filteredSelectedWebinarKeys.length;
    const numberOfSelectedRecordings = reduced_recordings.recordings.filteredSelectedRecordingKeys.length;

    const combinedStats = {
      filteredSelectedTotalRegistrants,
      filteredSelectedTotalEngagementCount,
      filteredTotalRegistrants,
      filteredTotalEngagementCount,
      numberOfSelectedSessions,
      numberOfSelectedWebinars,
      numberOfSelectedRecordings
    };
    return validateSelection(reportType, combinedStats);
  };

  generateReport = sendEmail => {
    const { reportType, reportFormatType } = this.state;
    const { user } = this.props.reduced_user;
    const { reduced_webinars, reduced_sessions, reduced_recordings, submitReportGenerationJob } = this.props;
    const sessionKeys =
      this.props.uniqueTableId === 'sesssionsTableInOverview'
        ? reduced_sessions.sessions.filteredSelectedSessionKeys
        : reduced_sessions.filterReportSessions.filteredSelectedSessionKeys;
    const webinarKeys = reduced_webinars.webinars.filteredSelectedWebinarKeys;
    const recordingKeys = reduced_recordings.recordings.filteredSelectedRecordingKeys;

    switch (reportType) {
      case ReportType.WEBINAR_ATTENDEE_REPORT:
        submitReportGenerationJob(reportType, reportFormatType, sessionKeys, user, sendEmail, true);
        break;
      case ReportType.WEBINAR_REGISTRATION_REPORT:
        submitReportGenerationJob(reportType, reportFormatType, webinarKeys, user, sendEmail, true);
        break;
      case ReportType.WEBINAR_RECORDING_REPORT:
        submitReportGenerationJob(reportType, reportFormatType, recordingKeys, user, sendEmail, true);
        break;
      default:
        return false;
    }
    this.props.toggle();
  };
}

export const WizardBreadCrumb = ({ reportType }, { t, wizard }) => {
  const { step } = wizard;
  let text = '';
  switch (reportType) {
    case ReportType.WEBINAR_REGISTRATION_REPORT:
      text = t('generateReport.wizard.breadCrumb.webinars');
      break;
    case ReportType.WEBINAR_RECORDING_REPORT:
      text = t('generateReport.wizard.breadCrumb.recordings');
      break;
    default:
      text = t('generateReport.wizard.breadCrumb.sessions');
  }

  const navigationSteps = [
    {
      id: WizardStepID.SELECT_REPORT_TYPE,
      iconClass: 'report-icon',
      title: t('generateReport.wizard.breadCrumb.report'),
      onClick: () => {
        wizard.push(WizardStepID.SELECT_REPORT_TYPE);
      }
    },
    {
      id: WizardStepID.FILTER_RECORDS,
      iconClass: 'sessions-icon',
      title: text,
      onClick: () => {
        wizard.push(WizardStepID.FILTER_RECORDS);
      }
    },
    {
      id: WizardStepID.SELECT_REPORT_FORMAT,
      iconClass: 'file-type-icon',
      title: t('generateReport.wizard.breadCrumb.fileType')
    }
  ];
  return <WizardBreadCrumbComponent navigationSteps={navigationSteps} activeStep={step} />;
};
WizardBreadCrumb.contextTypes = {
  t: PropTypes.func.isRequired,
  wizard: PropTypes.any.isRequired
};
WizardBreadCrumb.propTypes = {
  reportType: PropTypes.string
};

export const NavigateToReportTypeRow = ({ reportType, isBig, navigate }, { t }) => {
  return (
    <div className="navigationRow">
      <div className="reportTitle">
        {isBig && <div className={`${getReportTypeInfo(reportType).iconClass}`} />}
        <div className="title">{getReportTypeInfo(reportType).title}</div>
      </div>
      <div className="textLowerCase">
        <Button color="link" onClick={navigate}>
          {t('generateReport.wizard.editReportSelection')}
        </Button>
      </div>
    </div>
  );
};
NavigateToReportTypeRow.contextTypes = {
  t: PropTypes.func.isRequired
};
NavigateToReportTypeRow.propTypes = {
  reportType: PropTypes.string.isRequired,
  isBig: PropTypes.bool.isRequired,
  navigate: PropTypes.func
};

export const NavigateToFilterRecordsRow = (
  { reportType, numberOfSelectedSessions, numberOfSelectedWebinars, navigate, numberOfSelectedRecordings },
  { t }
) => {
  let text = null;
  let title = null;
  switch (reportType) {
    case ReportType.WEBINAR_ATTENDEE_REPORT:
      text = t('generateReport.wizard.nSessionsSelected', { count: numberOfSelectedSessions });
      title = t('generateReport.wizard.editSelectedSessions');
      break;
    case ReportType.WEBINAR_REGISTRATION_REPORT:
      text = t('generateReport.wizard.nWebinarsSelected', { count: numberOfSelectedWebinars });
      title = t('generateReport.wizard.editSelectedWebinars');
      break;
    case ReportType.WEBINAR_RECORDING_REPORT:
      text = t('generateReport.wizard.nRecordingsSelected', { count: numberOfSelectedRecordings });
      title = t('generateReport.wizard.editSelectedRecordings');
      break;
    default:
      return null;
  }

  return (
    <div className="navigationRow">
      <div>{text}</div>
      <div className="textLowerCase">
        <Button color="link" onClick={navigate}>
          {title}
        </Button>
      </div>
    </div>
  );
};
NavigateToFilterRecordsRow.contextTypes = {
  t: PropTypes.func.isRequired
};
NavigateToFilterRecordsRow.propTypes = {
  reportType: PropTypes.string,
  numberOfSelectedSessions: PropTypes.number.isRequired,
  numberOfSelectedWebinars: PropTypes.number.isRequired,
  numberOfSelectedRecordings: PropTypes.number.isRequired,
  selectedVirtualEventTitle: PropTypes.string.isRequired,
  numberOfSelectedVirtualEvents: PropTypes.number.isRequired,
  navigate: PropTypes.func.isRequired
};

export const NavigateButton = ({ reportType, isBig, disabled, stepId, push }, { t }) => {
  let text = null;
  switch (reportType) {
    case ReportType.WEBINAR_ATTENDEE_REPORT:
      text = t('generateReport.wizard.proceedSessions');
      break;
    case ReportType.WEBINAR_REGISTRATION_REPORT:
      text = t('generateReport.wizard.proceedWebinars');
      break;
    case ReportType.WEBINAR_RECORDING_REPORT:
      text = t('generateReport.wizard.proceedRecordings');
      break;
    default:
      text = t('generateReport.wizard.proceedSessions');
  }

  return (
    <React.Fragment>
      {stepId === WizardStepID.FILTER_RECORDS && (
        <Button color="primary" onClick={() => push(WizardStepID.SELECT_REPORT_FORMAT)} disabled={disabled}>
          {text}
        </Button>
      )}
      {!isBig && stepId === WizardStepID.SELECT_REPORT_TYPE && (
        <Button color="primary" onClick={() => push(WizardStepID.FILTER_RECORDS)} disabled={reportType === null}>
          {t('buttons.next')}
        </Button>
      )}
    </React.Fragment>
  );
};

NavigateButton.contextTypes = {
  t: PropTypes.func.isRequired
};
NavigateButton.propTypes = {
  reportType: PropTypes.string,
  isBig: PropTypes.bool,
  disabled: PropTypes.bool,
  stepId: PropTypes.string,
  push: PropTypes.func
};

export class WarningMessage extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  };
  static propTypes = {
    error: PropTypes.string,
    subMessage: PropTypes.string,
    moreInfoTooltip: PropTypes.string
  };

  render() {
    const { error, subMessage } = this.props;

    const errorMessage = error ? <div> {error}</div> : null;
    const subMessageElement = subMessage ? <div className="moreInfo">{subMessage}</div> : null;

    return (
      <div className="warningMessage">
        {errorMessage}
        {subMessageElement}
      </div>
    );
  }
}

export default connect(
  state => ({
    reduced_webinars: state.reduced_admin_webinars,
    reduced_sessions: state.reduced_admin_sessions,
    reduced_recordings: state.reduced_admin_recordings,
    reduced_user: state.reduced_user
  }),
  {
    submitReportGenerationJob: reportActions.submitReportGenerationJob
  }
)(GenerateReportWizard);



// WEBPACK FOOTER //
// ./src/GoToWebinar/GenerateReport/AdminWizard/GenerateAdminReportWizard.js